export default __webpack_public_path__ + "static/media/educators.d40ef5e1.webp";